import React from 'react';
import { jc } from 'utils';
import { ImagePlaceholder, ImageFallback } from 'common/components';
import { variantImage } from './variant-image.styles';

export interface VariantImageDataProps {
  axis: string;
  src: string;
}

export const DATA_QA_IMAGE_PLACEHOLDER = 'image-placeholder';

export type VariantImageProps = VariantImageDataProps & React.HTMLAttributes<HTMLDivElement>;

export const VariantImage: React.FC<VariantImageProps> = ({ src, axis, className = '' }) => {
  return (
    <ImagePlaceholder
      className={jc(variantImage, className)}
      src={src}
      loading="lazy"
      alt={axis}
      data-qa={DATA_QA_IMAGE_PLACEHOLDER}
      fallback={<ImageFallback width={48} height={48} />}
    />
  );
};
